const reportStatus = {
	name: 'Meldungsstatus',
	fields: {},
	processStep: 'Prozessschritt',
	process: {
		open: 'Offen',
		processing: 'In Arbeit',
		denied: 'Abgelehnt',
		done: 'Beendet',
	},
}

export default reportStatus
